// Drawer search entry: close the drawer, then open the search dialog. A dialog
// opened while the drawer is up renders behind it. Delegated on document: the
// drawer re-renders on section reload in the theme editor.
(function () {
  if (window.bqDrawerExtras) return;
  window.bqDrawerExtras = true;

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bq-open-search]');
    if (!b) return;
    e.preventDefault();

    // Cover the page before anything moves. Between the drawer closing and the
    // dialog opening the page underneath shows through for ~300ms; a veil
    // painted on the same frame as the tap hides that seam. Appended to the
    // body, not the drawer: the drawer is inside the <details> and stops
    // rendering the moment it closes.
    const veil = document.createElement('div');
    veil.className = 'bq-searchveil';
    veil.setAttribute('aria-hidden', 'true');
    veil.innerHTML =
      '<svg viewBox="0 0 44 44" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">' +
      '<circle class="bq-searchveil__ring" cx="19" cy="19" r="12"/>' +
      '<path class="bq-searchveil__stem" d="M28 28l9 9"/></svg>';
    document.body.appendChild(veil);
    requestAnimationFrame(() => veil.classList.add('is-on'));
    // Timer rather than transitionend: the dialog is in the top layer and hides
    // the veil anyway, so a missed event would leave an invisible full-screen
    // node swallowing taps.
    setTimeout(() => veil.remove(), 900);

    // The component's own close(), never `details.open = false`: the latter
    // collapses the panel while leaving `.menu-open` on the details, so the
    // summary keeps showing the cross and the next tap re-opens the menu.
    const drawer = b.closest('header-drawer');
    if (typeof drawer?.close === 'function') drawer.close();
    else b.closest('details.menu-drawer-container')?.removeAttribute('open');

    // showDialog() directly: a synthetic click on the header trigger does not
    // work, the theme's declarative binding ignores programmatic clicks. 320ms
    // because the drawer's own closing pass dismisses open dialogs, so the call
    // has to land after it.
    const modal = document.getElementById('search-modal');
    setTimeout(() => {
      if (typeof modal?.showDialog === 'function') modal.showDialog();
      else modal?.querySelector('dialog')?.showModal();
    }, 320);
  });
})();
